// QuotePopup.js
import React from 'react';
import styles from './quotePopup.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setLoginpopup } from '../../../redux/customerSlice';

const QuotePopup = () => {
  const { loginpopup } = useSelector(state => state.customer)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  if (!loginpopup) {
    return null
  }

  const handleClick = (path) => {
        navigate(`/${path}`,{state:'popup'})
        dispatch(setLoginpopup(false))
  }
  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContent}>
        <button className={styles.popupcloseButton} onClick={() => dispatch(setLoginpopup(false))}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 15L10 10M10 10L5 5M10 10L15 5M10 10L5 15" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

        </button>
        <div className={styles.popuptitle}>Quote or Order Request</div>
        {/* <div className={styles.popupmessage}>
          To create quotes you must upload items in Excel format.{' '}
          <span className={styles.popupuploadLink}>Upload file</span>
        </div> */}
        <div className={styles.popupmessage}>
          To create quotes or order you must be registered.
          <div>
            Please {'          '}
            <span className={styles.popupuploadLink} onClick={() => handleClick('login')}>Login</span> {' '}or {' '}
            <span className={styles.popupuploadLink} onClick={() => handleClick('register')}>Register</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotePopup;
